import React, { useEffect } from 'react';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseTextField from './ExpenseTextField';
import { AmountCurrencyInputAdornment } from './AmountCurrencyInputAdornment';
import { valueAsExpense } from '../../Utils/ValueAsUtils';
import { USDollarCurrency } from '../../Configurations/ExpenseEntryConfig';
import { USDollarCurrencyInputAdornment } from './USDollarCurrencyInputAdornment';

const BillAmount = (props) => {
    const {
        disabled,
        index,
        expense,
        isViewOnly,
        isInvoiceReviewLocked = false,
        isUsdOnly,
        updatePaymentTotalAmount = () => {},
    } = props;
    const { control, errors, getValues, trigger, watch, setValue } = useFormContext();

    const paymentCurrencyFieldName = `expenseEntries[${index}].paymentCurrency`;
    const paymentCurrencyValue = watch(paymentCurrencyFieldName);
    useEffect(() => {
        // if the expense is set to be USD only, set the currency to USD in case it is not
        if (isUsdOnly && paymentCurrencyValue !== USDollarCurrency.value) {
            setValue(paymentCurrencyFieldName, USDollarCurrency.value);
        }
    }, [isUsdOnly, paymentCurrencyValue, paymentCurrencyValue, setValue]);

    return (
        <Grid2 item size={4}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].billAmount`}
                defaultValue={expense?.billAmount}
                rules={{
                    validate: (v) => {
                        if (v === '' || v == null) return 'Amount is required';
                        const other = getValues(`expenseEntries[${index}].payAmount`);
                        const a = Number(v);
                        const b = Number(other || 0);
                        if (Number.isNaN(a)) return 'Enter a valid number';
                        if (a > 99999.99) return "Amount can't exceed 99,999.99";
                        if (a === 0 && b === 0)
                            return 'Payment Amount and Bill Amount cannot both be 0';
                        return true;
                    },
                }}
                render={({ onChange, value }) => (
                    <ExpenseTextField
                        required
                        placeholder="0.00"
                        id="bill-amount"
                        onChange={(e) => {
                            onChange(valueAsExpense(e.target.value));
                            updatePaymentTotalAmount();
                            trigger([
                                `expenseEntries[${index}].billAmount`,
                                `expenseEntries[${index}].payAmount`,
                            ]);
                        }}
                        value={value}
                        label="Bill Amount"
                        endAdornment={
                            isUsdOnly ? (
                                <USDollarCurrencyInputAdornment />
                            ) : (
                                <AmountCurrencyInputAdornment
                                    disabled={disabled || isViewOnly || isInvoiceReviewLocked}
                                    index={index}
                                    currencyType={expense.currency}
                                    name={`expenseEntries[${index}].paymentCurrency`}
                                />
                            )
                        }
                        error={Boolean(errors.expenseEntries?.[index]?.billAmount)}
                        disabled={isViewOnly || isInvoiceReviewLocked}
                        helperText={errors.expenseEntries?.[index]?.billAmount?.message}
                    />
                )}
            />
        </Grid2>
    );
};

export default BillAmount;
